const styles = {
  container: { 
    padding: '30px', 
    background: '#f4f6f9', 
    minHeight: '100vh',
    fontFamily: 'Segoe UI, sans-serif',
    transition: 'margin-left 0.3s ease'
  },
  header: { 
    color: '#1B019B', 
    fontWeight: '600', 
    fontSize: '1.5rem' 
  },
  hr: { 
    width: '80px', 
    border: '2px solid #1B019B', 
    opacity: '1', 
    margin: '10px auto' 
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  title: { 
    color: "#1B019B", 
    fontSize: "28px", 
    fontWeight: "bold", 
    marginBottom: "20px" 
  },
  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '30px',
    gap: '15px'
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  filterIcon: { 
    color: '#1B019B',
    fontSize: '16px'
  },
  searchBar: {
    borderRadius: '20px',
    padding: '8px 12px 8px 35px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    minWidth: '250px',
    height: '38px'
  },
  dateInput: {
    borderRadius: '20px',
    padding: '8px 12px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    minWidth: '150px',
    height: '38px'
  },
  select: {
    borderRadius: '20px',
    padding: '7px 12px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    minWidth: '180px',
    height: '38px'
  },
  pageSizeLabel: { 
    color: '#1B019B', 
    fontWeight: 500,
    whiteSpace: 'nowrap'
  },
  exportButton: { 
    minWidth: '160px', 
    padding: '8px 14px', 
    fontSize: '1rem',
    borderRadius: '20px'
  },
  tableHeader: { 
    backgroundColor: '#1B019B', 
    color: '#fff' 
  },
  paginationButton: { 
    backgroundColor: '#1B019B', 
    color: 'white', 
    border: 'none', 
    margin: '0 2px', 
    borderRadius: '5px', 
    padding: '5px 10px' 
  },
  paginationActive: { 
    backgroundColor: '#0d0066', 
    color: 'white' 
  },
  paginationDisabled: { 
    backgroundColor: '#e0e0e0', 
    color: '#a0a0a0', 
    cursor: 'not-allowed' 
  },
  justifierBtn: { 
    backgroundColor: '#1B019B', 
    color: '#fff', 
    border: 'none', 
    padding: '5px 15px', 
    borderRadius: '5px'
  },
  modalBtn: {
    backgroundColor: '#1B019B',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 25px',  
    fontSize: '15px',       
    cursor: 'pointer',
    minWidth: '120px',      
    fontWeight: '500',
    transition: 'background 0.3s ease'
  },
  detailButton: {
    background: 'none',
    border: 'none',
    color: '#1B019B',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontWeight: '500',
  },
  fileLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    border: '1px solid #1B019B',
    borderRadius: '6px',
    color: '#1B019B',
    textDecoration: 'none',
    fontWeight: '500',
    transition: 'all 0.2s',
  }
};

export default styles;